package com.starparty.app.astro0

import com.starparty.app.vector_maths.Matrix4d
import com.starparty.app.vector_maths.Point3d
import kotlin.math.*

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
open class SphericalCoords
constructor(var itsRotation: Matrix4d = Matrix4d()) {
    protected var itsInverseRot = Matrix4d()
    protected var itsRotIncMatrix = Matrix4d()
    protected var isInverseRotCurrent = false
    fun rotAroundPoint(
        radians: Double,
        att: Double,
        elv: Double
    ) {

// Log.v("SP2", "Sherical_Coords radians:$radians")
        itsRotIncMatrix.rotY(att)
        itsRotation.mul(itsRotIncMatrix)
        itsRotIncMatrix.rotX(-elv)
        itsRotation.mul(itsRotIncMatrix)
        itsRotIncMatrix.rotZ(radians)
        itsRotation.mul(itsRotIncMatrix)
        itsRotIncMatrix.rotX(elv)
        itsRotation.mul(itsRotIncMatrix)
        itsRotIncMatrix.rotY(-att)
        itsRotation.mul(itsRotIncMatrix)
        isInverseRotCurrent = false
    }

    fun applyRotation(cartesian: Point3d) {
        applyMatrix(cartesian, itsRotation)
    }

    fun rotY(radians: Double) {
        itsRotIncMatrix.rotY(radians)
        mulRotation(itsRotIncMatrix)
    }

    fun rotX(radians: Double) {
        itsRotIncMatrix.rotX(radians)
        mulRotation(itsRotIncMatrix)
    }

    fun rotZ(radians: Double) {
        itsRotIncMatrix.rotZ(radians)
        mulRotation(itsRotIncMatrix)
    }

    protected fun mulRotation(mul: Matrix4d?) {
        itsRotation.mul(mul)
        isInverseRotCurrent = false
    }

    val inverseRotation: Matrix4d
        get() {
           if (!isInverseRotCurrent) {
                itsInverseRot.invert(itsRotation)
                isInverseRotCurrent = true
            }

            return itsInverseRot
        }


    fun invertRotateCartesian(c: Point3d): Point3d {
        val m = inverseRotation
        val p0 = c.x * m.m00 + c.y * m.m10 + c.z * m.m20 + m.m30
        val p1 = c.x * m.m01 + c.y * m.m11 + c.z * m.m21 + m.m31
        val p2 = c.x * m.m02 + c.y * m.m12 + c.z * m.m22 + m.m32
        val p3 = c.x * m.m03 + c.y * m.m13 + c.z * m.m23 + m.m33
       // c[px / pw, py / pw] = pz / pw
        val cRot = Point3d(p0 / p3, p1 / p3, p2 / p3)

        return cRot
    }

    companion object {
        fun applyMatrix(c: Point3d, m: Matrix4d) {
            val p0 = c.x * m.m00 + c.y * m.m10 + c.z * m.m20 + m.m30
            val p1 = c.x * m.m01 + c.y * m.m11 + c.z * m.m21 + m.m31
            val p2 = c.x * m.m02 + c.y * m.m12 + c.z * m.m22 + m.m32
            val p3 = c.x * m.m03 + c.y * m.m13 + c.z * m.m23 + m.m33

            c.x = p0 / p3
            c.y = p1 / p3
            c.z = p2 / p3

        }

        /** Converts the cartesian coordinates (x,y) on a
         * unit sphere to spherical coordinates in radians
         * and places the result in 'sph' as (att, elv).  */
        fun cartesianToSpherical(
                cart: Point3d,
                sph: SphPoint
        ) {
            if (cart.y > 1) {
                console.log ("cartesianToSpherical error: cart.y rounds above 1")
                cart.y = 1.0 // correction of cart.y, as sometimes rounds above 1 giving error.
            }
            if (cart.y < -1) {
                console.log ("cartesianToSpherical error: cart.y rounds below -1")
                cart.y = -1.0 // correction of cart.y, as sometimes rounds below -1 giving error.
            }

          //  cart.y = min(1.0, cart.y) // Sometimes rounds above 1 or
         //   cart.y = max(-1.0, cart.y) // below -1 giving error.
            val A = asin(cart.y)

            sph.elv = A

            var B = cart.x / cos(sph.elv)

            if (B > 1) {
                console.log ("cartesianToSpherical error: B rounds above 1")
                B = 1.0 // correction of cart.y, as sometimes rounds above 1 giving error.
            }
            if (B < -1) {
                console.log ("cartesianToSpherical error: B rounds below -1")
                B = -1.0 // correction of cart.y, as sometimes rounds below -1 giving error.
            }

        //    B = min(1.0, B) // Sometimes rounds above 1 or
       //     B = max(-1.0, B) // below -1 giving error.
            sph.att = asin(B)

            if (cart.z < 0) {
            //    console.log ("cartesianToSpherical: cart.z < 0")
                sph.att = PI - sph.att

            } /*else if (sph.att < 0) {
            //    console.log ("cartesianToSpherical: sph.att < 0")
                sph.att = (2 * PI) + sph.att
            }*/
        }

        /** Converts the equatorial coordinates (elv, att) in
         * radians to cartesian coordinates on a unit sphere
         * and places the result in 'cart'.  */
        fun sphericalToCartesian(
            att: Double,
            elv: Double,
            cart: Point3d
        ) {
            cart.x = cos(elv) * sin(att)
            cart.y = sin(elv)
            cart.z = cos(elv) * cos(att)

//console.log("sphToCart att: $att, elv: $elv")
//console.log("sphToCart: cart"+ cart.x + " " + cart.y +" " + cart.z)
val sph = SphPoint()
            cartesianToSpherical(cart, sph)
//console.log("sphToCart att2: ${sph.att}, elv2: ${sph.elv}")
        }
    }

}